module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--6-51c8b5d9c76e4db094b41b98fe1bbd1c.jpg";